import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import MoneyIcon from  '@material-ui/icons/Brightness5Outlined';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
                               
  icon: {
    color: theme.palette.warning.main,
    height: 24,
    width: 24                    
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));

const SunriseCard = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              Sunrise 
            </Typography>
            <Typography variant="h3">06:00:02</Typography>
          </Grid>
          <Grid item>
            <MoneyIcon className={classes.icon} />
          </Grid>
        </Grid> 
      </CardContent>
    </Card>
  );
};

SunriseCard.propTypes = {
  className: PropTypes.string
};

export default SunriseCard;
